export type Poll1Draft = {
  answers: (boolean | null)[];
  notes: string;
  evidence: Record<string, string>;
};

export const hasPartialPoll1Answers = (answers: (boolean | null)[]): boolean =>
  answers.some(a => a !== null);

const normalizePoll1Draft = (raw: unknown): Poll1Draft | null => {
  if (!raw || typeof raw !== "object") return null;
  const draft = raw as Poll1Draft;
  if (!Array.isArray(draft.answers)) return null;
  return {
    answers: draft.answers,
    evidence: draft.evidence ?? {},
    notes: draft.notes ?? "",
  };
};

export const draftFromAccount = (
  account:
    | {
        poll1_draft?: Poll1Draft | null;
      }
    | null
    | undefined
): Poll1Draft | null => normalizePoll1Draft(account?.poll1_draft);

export const accountHasPoll1Draft = (account: {
  poll1_has_draft?: boolean;
  poll1_submitted_at?: string | null;
}): boolean => Boolean(account.poll1_has_draft && !account.poll1_submitted_at);
